<template lang="pug">
  .component-client-action-buttons
    ActionButton(:action="remove", :confirm="true", color-class="warning" ) Delete
</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from "src/maggieHelper"
import ActionButton from "../ActionButton";

export default {
  name: "VehicleNoteButtons",
  components: {ActionButton},
  data() {
    return {
      entity: null
    }
  },
  created() {
  },
  methods: {
    remove: function () {
      return KeplerBackofficeSdk.notes.select(this.item).remove(() => {
        this.$emit('itemUpdated')
        MaggieHelper.notification('delete-esit', "Note removed")
      })
    },
  },
  props: ['item']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VehicleNoteButtons.vue?acfe4a32